import React from 'react';
import { TableFilter } from './TableFilter';
import { Input } from 'components/shadcn/ui/input';

export const TableController = (props) => {
    const {
        data,
        columns,
        filterBy,
        setFilterBy,
        search,
        onSearchChange,
        canFilter,
        canSearch,
        setSortField,
        customFilters,
        renderSearchInput,
    } = props;

    return !data || data.length === 0 ? null : (
        <div>
            <div className="flex flex-grow flex-col items-end gap-3 px-5 pb-5 sm:flex-row">
                {canFilter && (
                    <TableFilter
                        columns={columns}
                        filterBy={filterBy}
                        setFilterBy={setFilterBy}
                        setSortField={setSortField}
                        onSearchChange={onSearchChange}
                    />
                )}
                {canSearch &&
                    (renderSearchInput ? (
                        renderSearchInput()
                    ) : (
                        <Input
                            placeholder="Search..."
                            value={search}
                            className="w-full"
                            onChange={({ currentTarget }) => {
                                onSearchChange(currentTarget.value);
                            }}
                        />
                    ))}
            </div>
            {customFilters}
        </div>
    );
};
